// Clarity SDK is not supported on web - these are no-op functions

export const initClarity = () => {
    // No-op: Clarity is mobile-only
};

export const setClarityUser = (_userId: string) => {
    // No-op: Clarity is mobile-only
};

export const setClarityScreenName = (_screenName: string) => {
    // No-op: Clarity is mobile-only
};

export const setClarityTag = (_key: string, _value: string) => {
    // No-op: Clarity is mobile-only
};

export const logClarityEvent = (_eventName: string) => {
    // No-op: Clarity is mobile-only
};

export const setClaritySessionTag = (_key: string, _value: string) => {
    // No-op: Clarity is mobile-only
};
